module.exports = __webpack_public_path__ + "static/img/check_use.3edba42a.png";